import { Link } from 'react-router-dom'
import quote1 from '../../images/quote/shape-1.png'
import quote2 from '../../images/quote/shape-2.png'

const Quote2: React.FC = () => {
    
    return (
        <section className="wpo-quote-section-s2">
            <div className="container">
                <div className="quote-wrap">
                    <div className="row text-center align-items-center">
                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="quote-title">
                                <h2 className="poort-text poort-in-right">“Every time I look at you, I fall in love all over
                                    again.”</h2>
                                <p>It’s not just the way your eyes catch the light, or the curve of your smile—it’s the
                                    way you make the world feel softer,
                                    warmer, and more alive. Each glance reminds me of every reason I fell for you the
                                    first time, and yet somehow, you give
                                    me new reasons every day.</p>
                                <div className="quote-btn">
                                    <Link to="/about" className="theme-btn">Let’s Celebrate Our Love</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="shape-1 wow fadeInLeftSlow" data-wow-duration="1400ms">
                    <img src={quote1} alt=""/>
                </div>
                <div className="shape-2 wow fadeInRightSlow" data-wow-duration="1800ms">
                    <img src={quote2} alt=""/>
                </div>
            </div>
        </section>
    )
}

export default Quote2;